export const USER_GUEST = 'user/guest/'
export const USER_GUEST_ALL = `${USER_GUEST}all`
